import { FormOption } from '../../types'

export const getCheckedFormOptionsValue = (departments: FormOption[]): string[] => departments
    .filter(departmentOption => departmentOption.isChecked)
    .map(departmentOption => departmentOption.value)
